import React from "react";
/*
 * Backpack - Skyscanner's Design System
 *
 * Copyright 2016 Skyscanner Ltd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LgSpinner = function LgSpinner(props) {
  return /*#__PURE__*/_jsxs("svg", {
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 6.657a.946.946 0 0 1-.943-.943V1.943c0-.519.424-.943.943-.943.519 0 .943.424.943.943v3.771a.946.946 0 0 1-.943.943z",
      clipRule: "evenodd",
      opacity: ".65"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.671 7.373a.946.946 0 0 1-.345-1.288l1.886-3.266a.946.946 0 0 1 1.288-.345c.45.26.604.839.345 1.288L15.96 7.028a.946.946 0 0 1-1.288.345z",
      clipRule: "evenodd",
      opacity: ".75"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.627 9.329a.945.945 0 0 1 .345-1.288l3.266-1.886a.946.946 0 0 1 1.288.345.946.946 0 0 1-.345 1.288l-3.266 1.886a.946.946 0 0 1-1.288-.345z",
      clipRule: "evenodd",
      opacity: ".85"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.343 12c0-.519.424-.943.943-.943h3.771c.519 0 .943.424.943.943a.946.946 0 0 1-.943.943h-3.771a.946.946 0 0 1-.943-.943z",
      clipRule: "evenodd",
      opacity: ".9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.627 14.671a.946.946 0 0 1 1.288-.345l3.266 1.886c.45.26.604.839.345 1.288a.946.946 0 0 1-1.288.345l-3.266-1.886a.946.946 0 0 1-.345-1.288z",
      clipRule: "evenodd",
      opacity: ".2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.671 16.627a.946.946 0 0 1 1.288.345l1.886 3.266a.946.946 0 0 1-.345 1.288.945.945 0 0 1-1.288-.345l-1.886-3.266a.946.946 0 0 1 .345-1.288z",
      clipRule: "evenodd",
      opacity: ".25"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 17.343c.519 0 .943.424.943.943v3.771A.946.946 0 0 1 12 23a.946.946 0 0 1-.943-.943v-3.771c0-.519.424-.943.943-.943z",
      clipRule: "evenodd",
      opacity: ".3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.329 16.627c.449.26.604.839.345 1.288l-1.886 3.266a.945.945 0 0 1-1.288.345.946.946 0 0 1-.345-1.288l1.886-3.266a.946.946 0 0 1 1.288-.345z",
      clipRule: "evenodd",
      opacity: ".35"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.373 14.671a.946.946 0 0 1-.345 1.288l-3.266 1.886a.946.946 0 0 1-1.288-.345.946.946 0 0 1 .345-1.288l3.266-1.886a.946.946 0 0 1 1.288.345z",
      clipRule: "evenodd",
      opacity: ".4"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.657 12a.946.946 0 0 1-.943.943H1.943A.946.946 0 0 1 1 12c0-.519.424-.943.943-.943h3.771c.519 0 .943.424.943.943z",
      clipRule: "evenodd",
      opacity: ".45"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.373 9.329a.946.946 0 0 1-1.288.345L2.819 7.788A.946.946 0 0 1 2.474 6.5a.946.946 0 0 1 1.288-.345L7.028 8.04a.946.946 0 0 1 .345 1.288z",
      clipRule: "evenodd",
      opacity: ".5"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.329 7.373a.946.946 0 0 1-1.288-.345L6.155 3.762A.946.946 0 0 1 6.5 2.474a.946.946 0 0 1 1.288.345l1.886 3.266a.946.946 0 0 1-.345 1.288z",
      clipRule: "evenodd",
      opacity: ".55"
    })]
  });
};
LgSpinner.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
import { cssModules } from "../../bpk-react-utils";
import SPINNER_TYPES from "./spinnerTypes";
import STYLES from "./BpkSpinner.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getClassName = cssModules(STYLES);
const BpkLargeSpinner = ({
  alignToButton = false,
  className = null,
  type = SPINNER_TYPES.dark,
  ...rest
}) => {
  const classNames = getClassName('bpk-spinner', 'bpk-spinner--large', `bpk-spinner--${type}`, alignToButton && 'bpk-spinner--align-to-large-button', className);
  return /*#__PURE__*/_jsx("span", {
    className: classNames,
    children: /*#__PURE__*/_jsx(LgSpinner, {
      ...rest
    })
  });
};
export default BpkLargeSpinner;